import { Component } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { UtilsService } from "../../../../auth/service/utils.service";
import { UserService } from "../../../../auth/service";
import moment from "moment/moment";
import { EmployeeCostsService } from "../../employee-costs.service";

@Component({
  selector: "app-update-contract-costs",
  templateUrl: "./update-contract-costs.component.html",
  styleUrls: ["./update-contract-costs.component.scss"],
})
export class UpdateContractCostsComponent {
  public contentHeader: IContentHeader;
  private employees: any = [];
  public uploadedData: any;
  public fileName: string = "";
  public errors: string[] = [];
  public updateErrors: string[] = [];
  public openedErrorTab: string = "";
  public processedItems: number = 0;
  public hideUploadButton: boolean = true;
  public startUpdating: boolean = false;

  constructor(
    public _utilService: UtilsService,
    private _userService: UserService,
    private _employeeCostsService: EmployeeCostsService,
  ) {
    this.contentHeader = {
      headerTitle: "UPDATE_EMPLOYEE_CONTRACT_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "UPDATE_EMPLOYEE_CONTRACT_COSTS",
            isLink: false,
          },
        ],
      },
    };
  }

  async handlerChangeFileInput($event: any) {
    this.employees = await this._userService.getList("employee", null, true, "firstname,lastname,hash,badge_number");
    this._utilService.showLoading();
    this.fileName = $event.target.files[0].name;
    if ($event.target.files && $event.target.files[0]) {
      this._utilService.parseXLSX(
        $event.target.files[0],
        ["complete_name", "level", "badge_number", "gross_monthly_13", "salary_yearly_gross"],
        { raw: true, defval: 0, header: ["A", "B", "C", "D", "E"] },
        async (data: any) => {
          const errorMessage: string = await this._utilService.translate("EMPLOYEE_NOT_FOUND");
          this.uploadedData = data
            .slice(3)
            .map((item: any) => {
              const existsEmployee: any = this.employees.find((emp: any) => Number(emp.badge_number) === item.badge_number);

              if (!existsEmployee) {
                this.errors.push(`${item.complete_name} ${errorMessage}`);
                return null;
              }

              item.level = item.level.split(" ").pop();
              item.user_hash = existsEmployee.hash;
              item.net_monthly_12 = Number(item.net_monthly_12);
              item.salary_yearly_gross = Number(item.salary_yearly_gross);
              item.status_calculating = 0;
              item.status_update = -1;

              return item;
            })
            .filter((item: any) => item);
          this._utilService.hideLoading();
          await this.calculateCosts();
        },
        0,
      );
    }
  }

  async calculateCosts() {
    for (let record of this.uploadedData) {
      const calculatedCost: any = await this._employeeCostsService.calculateMonthlyCosts(record.user_hash, record.salary_yearly_gross);
      record.gross_monthly_12 = calculatedCost.gross_monthly_12;
      record.net_monthly_12 = calculatedCost.net_monthly_12;
      record.net_monthly_13 = calculatedCost.net_monthly_13;
      record.total_daily = calculatedCost.total_daily;
      record.total_net_monthly_13 = calculatedCost.total_net_monthly_13;
      record.current_contract = calculatedCost.current_contract;
      record.status_calculating = 1;
      record.status_update = 0;
      record.production_bonus = calculatedCost.current_contract.production_bonus;
      this.processedItems++;
    }
    this.hideUploadButton = false;
  }

  async update() {
    this.hideUploadButton = true;
    this.processedItems = 0;
    this.startUpdating = true;

    for (const record of this.uploadedData) {
      record.status_update = 1;

      const data: any = {
        contract: record.current_contract.contract,
        level: record.level,
        program: record.current_contract.program,
        role: record.current_contract.role,
        start_date: record.current_contract.start_date,
        end_date: record.current_contract.end_date,
        trial: record.current_contract.trial,
        bonus: Number(record.current_contract.bonus),
        gross_monthly_12: record.gross_monthly_12,
        salary_yearly_gross: record.salary_yearly_gross,
        net_monthly_12: record.net_monthly_12,
        net_monthly_13: record.net_monthly_13,
        total_daily: record.total_daily,
        total_net_monthly_13: record.total_net_monthly_13,
        ticket_card: record.current_contract.ticket_card,
        ticket_month_number: record.current_contract.ticket_month_number,
        ticket_value: record.current_contract.ticket_value,
        ticket_type: record.current_contract.ticket_type,
        production_bonus: record.current_contract.production_bonus,
      };

      this._userService
        .updateEmployeeContract(record.user_hash, data, "?dont_send_notification=1")
        .then(async () => {
          record.status_update = 2;
          this.processedItems++;
        })
        .catch(async (err: any) => {
          let text: string = "ERROR_UPDATE_EMPLOYEE_CONTRACT";
          if (err === "Cannot edit closed contract") {
            text = "ERROR_UPDATE_EMPLOYEE_CONTRACT_CONTRACT_CLOSED";
          }
          record.status_update = 3;
          const message: string = await this._utilService.translate(`ALERT.${text}`);
          this.updateErrors.push(`${message} (${record.complete_name})`);
          this.processedItems++;
        });
    }

    await this._utilService.updateOption("last_employee_contracts_update", moment().format("YYYY-MM-DD HH:mm:ss"), false);
  }
}
